export default __webpack_public_path__ + "static/media/HeroImg.89fc8c8e.jpg";